import "./Skills.css";

const skills = [
    { name: "React", icon: "react" },
    { name: "Node.js", icon: "nodejs" },
    { name: "HTML", icon: "html" },
    { name: "CSS", icon: "css" },
    { name: "Vercel", icon: "vercel" },
    { name: "C#", icon: "cs" },
    { name: ".NET", icon: "dotnet" },
    { name: "Python", icon: "py" },
    { name: "PyTorch", icon: "pytorch" },
    { name: "TensorFlow", icon: "tensorflow" },
    { name: "Git", icon: "git" },
    { name: "Github", icon: "github" },
    { name: "VisualStudio", icon: "visualstudio" },
    { name: "VScode", icon: "vscode" },
    { name: "Matlab", icon: "matlab" },
    { name: "Blender", icon: "blender" },
    { name: "Obsidian", icon: "obsidian" },
    { name: "Markdown", icon: "md" },
];

const Skills = () => {
    return (
        <section className="skills-container" id="skills">
            <h2>Skills</h2>
            <div className="skills-grid">
                {skills.map((skill) => (
                    <div className="skill-card" key={skill.name}>
                        <img src={`https://skillicons.dev/icons?i=${skill.icon}`} className="skill-icon"/>
                        <p>{skill.name}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Skills;